const API_KEY = process.env.REACT_APP_KAZHAVDA_API_KEY;
const FALLBACK_HOST = "api.kazhavda.mk";
const API_BASE = process.env.REACT_APP_API_BASE || `https://${FALLBACK_HOST}`;

const TARGET_HOSTS = (() => {
  const hosts = new Set([FALLBACK_HOST]);
  try {
    const baseHost = new URL(API_BASE).hostname;
    if (baseHost) hosts.add(baseHost);
  } catch {
    // ignore
  }
  return hosts;
})();

const getUrlHostname = (input) => {
  try {
    const url = typeof input === "string" ? input : input?.url;
    if (!url) return null;
    return new URL(url, window.location.origin).hostname;
  } catch (err) {
    console.error("Failed to parse request URL", err);
    return null;
  }
};

const shouldAttachApiKey = (input) => {
  const hostname = getUrlHostname(input);
  return hostname ? TARGET_HOSTS.has(hostname) : false;
};

export const withApiKeyHeaders = (input, headersInit = {}) => {
  const headers = new Headers(headersInit);
  if (!API_KEY) return headers;
  if (!shouldAttachApiKey(input)) return headers;
  headers.set("Authorization", `Api-Key ${API_KEY}`);
  return headers;
};

export function installApiKeyFetchInterceptor() {
  if (typeof window === "undefined") return;
  if (window.__kazhavdaApiKeyFetchPatched) return;
  if (!API_KEY) {
    console.warn("REACT_APP_KAZHAVDA_API_KEY is not set; requests to api.kazhavda.mk will miss the Api-Key header.");
    return;
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    if (!shouldAttachApiKey(input)) return originalFetch(input, init);

    if (input instanceof Request) {
      const headers = withApiKeyHeaders(input, init.headers || input.headers);
      const request = new Request(input, { ...init, headers });
      return originalFetch(request);
    }

    const headers = withApiKeyHeaders(input, init.headers);
    return originalFetch(input, { ...init, headers });
  };

  window.__kazhavdaApiKeyFetchPatched = true;
}
